import type { TyreEventType, TyreStatus } from '@chukua/common';

export const TYRE_STATUS_LABELS: Record<TyreStatus, string> = {
  new: 'New',
  in_stock: 'In stock',
  fitted: 'Fitted',
  worn: 'Worn',
  replaced: 'Replaced',
  scrapped: 'Scrapped',
};

/** Ant Tag presets, which follow the brand palette. */
export const TYRE_STATUS_COLORS: Record<TyreStatus, string> = {
  new: 'blue',
  in_stock: 'default',
  fitted: 'success',
  worn: 'warning',
  replaced: 'default',
  scrapped: 'error',
};

export const TYRE_EVENT_LABELS: Record<TyreEventType, string> = {
  registered: 'Registered',
  fitted: 'Fitted',
  rotated: 'Rotated',
  wear_reading: 'Wear reading',
  marked_worn: 'Marked worn',
  repaired: 'Puncture repaired',
  retreaded: 'Retreaded',
  removed: 'Removed',
  scrapped: 'Scrapped',
};

const number = new Intl.NumberFormat('en-KE');

export function formatKm(km: number | null): string {
  return km === null ? '—' : `${number.format(km)} km`;
}

export function formatDepth(mm: number | null): string {
  return mm === null ? '—' : `${mm} mm`;
}
